// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags-dropdown[data-v-f1bc60ce]{margin:10px 0}", ""]);
// Exports
module.exports = exports;
